export const customId = (id: string) => {
  return id.includes('contract_general') ? 'contract_general' : id;
};
